/**
 * Copia a memoria archivos que vienen del sistema operativo (selector o
 * arrastrar y soltar).
 *
 * Un `File` del navegador es una referencia al archivo en disco, no su
 * contenido: Chromium fija tamaño y fecha de modificación cuando se leen sus
 * propiedades y, si el archivo cambia o desaparece antes de subirlo, aborta la
 * petición con ERR_UPLOAD_FILE_CHANGED sin llegar al servidor. Pasa con
 * archivos temporales que crea la aplicación de origen al arrastrar (Outlook,
 * carpetas comprimidas) y con archivos sincronizados en la nube. Leer los bytes
 * al adjuntar deja un `File` en memoria que ya no depende del disco.
 */
export async function snapshotFiles(files: File[]): Promise<{ files: File[]; failed: string[] }> {
  const ok: File[] = [];
  const failed: string[] = [];

  for (const file of files) {
    try {
      const bytes = await file.arrayBuffer();
      ok.push(new File([bytes], file.name, { type: file.type, lastModified: file.lastModified }));
    } catch {
      failed.push(file.name);
    }
  }

  return { files: ok, failed };
}
